export default __webpack_public_path__ + "static/media/li.1797fad3.svg";